import React, { FC } from 'react';

import { Box, Divider, Typography } from '@mui/material';

interface IconCardHeaderProps {
  icon: React.ElementType;
  title: string;
  action?: React.ReactNode;
}

const IconCardHeader: FC<IconCardHeaderProps> = ({ icon: Icon, title, action }) => (
  <>
    <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
      <Box display="flex" alignItems="center">
        <Icon color="primary" sx={{ mr: 1 }} />
        <Typography variant="h6" fontWeight="600">
          {title}
        </Typography>
      </Box>
      {action}
    </Box>
    <Divider sx={{ mb: 1 }} />
  </>
);

export default IconCardHeader;
